<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
 
  import {SEARCH_LEADERS} from '../../graphql/leaders';
  
  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';
  import Leader from './components/leader.html';
  import Plus from '../../components/buttons/plus';
  import Link from '../../utils/link';
  import Search from '../../components/inputs/search';

  let search = '';
  let query = client.watchQuery({ query: SEARCH_LEADERS, fetchPolicy: 'network-only', variables: {search} });
  let results = {loading: true};

  function setResponse({data, loading, error, networkStatus}) {
    results = {
      loading,
      page: data && data.leaders ? data.leaders.page : 1,
      total: data && data.leaders ? data.leaders.total : 0,
      leaders: data && data.leaders ? data.leaders.docs : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function searchLeaders() {
    query.refetch({search, page: 1});
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search,
        page: results.page + 1
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          people: {
            ...fetchMoreResult.leaders,
            docs: [...prev.leaders.docs, ...fetchMoreResult.leaders.docs]
          }
        });
      }
    });
  }
</script>




<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>{results.total || 0} Event Leaders</h1>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <Link href="/leaders/new">
      <Plus label="ADD EVENT LEADER" />
    </Link>
  </div>
  <!--<div class="cell small-12 medium-12">
    <Search on:input={searchLeaders} bind:value={search} placeholder={'Search Event Leaders'}  />
  </div>-->
  <div class="cell small-12 medium-12">
    {#if results.loading}
      <Loader></Loader>
    {/if}
    {#if !results.loading}
      <div class="grid-x grid-margin-x small-up-1 medium-up-3">
        {#each results.leaders as leader, i}
          <div class="cell">
            <Leader leader={leader} />
          </div>
        {/each}
      </div>
    {/if}
  </div>
</div>
